<div class="wrapper">
  <div class="tile">
    <h2 class="inter h2 w700">{{ 'app.stores-vop.title' | i18n }}</h2>
    <div class="store-list">
      @for (store of stores; track store) {
        <app-store-tile [store]="store"></app-store-tile>
      }
    </div>
  </div>
</div>


